<template>
  <div class="page">
    <div v-if="getModuleConfig('external_member_customer_bind.duplicate_registration.step_section.enable_step_section')" class="p-3">
      <SharedStep :steps="getModuleConfig('thanks_page.step_section.steps')" />
    </div>

    <div v-if="formTitle" class="page__title">
      {{ formTitle }}
    </div>
    <div v-if="formDesc" class="page__desc">
      {{ formDesc }}
    </div>

    <div class="page__content" v-if="contentData" v-html="contentData"></div>

    <img
      v-for="image in contentImages"
      :src="image.image_url"
      :key="image.order"
      class="w-100"
    />

    <div class="page__button s-space-y-4">
      <MemberButton
        v-if="buttonText"
        :button-text="buttonText"
        :button-url="getModuleConfig('external_member_customer_bind.duplicate_registration.button_url')"
        :type="getModuleConfig('external_member_customer_bind.duplicate_registration.button_action')"
      ></MemberButton>
    </div>
  </div>
</template>

<script>
import registerMixin from "@/mixins/liff/register";
import MemberButton from "@/components/Page/Liff/Shared/MemberButton.vue";
import SharedStep from "@/components/Page/Liff/Shared/Steps";

export default {
  mixins: [registerMixin],
  components: {
    SharedStep,
    MemberButton,
  },
  computed: {
    formTitle() {
      return this.getModuleConfig("external_member_customer_bind.duplicate_registration.form_title");
    },
    formDesc() {
      return this.getModuleConfig("external_member_customer_bind.duplicate_registration.form_desc");
    },
    contentImages() {
      let contentImages = this.getModuleConfig("external_member_customer_bind.duplicate_registration.content_images") || [];
      contentImages.sort((a, b) => a.order - b.order);
      return contentImages;
    },
    contentData() {
      return this.getModuleConfig("external_member_customer_bind.duplicate_registration.content") ?? false;
    },
    buttonText() {
      return this.getModuleConfig("external_member_customer_bind.duplicate_registration.button_text");
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  max-width: 425px;
  margin: auto;
}

.item {
  display: flex;
  margin-bottom: 16px;

  &__text {
    color: var(--liff-primary_text_color);
    font-size: 15px;
    line-height: 24px;
    font-weight: 500;
    margin-left: 8px;
  }
}
</style>
